// export const DigitalTransfer = '1';
export const Flock = '2';
// export const OffsetTransfer = '3';
// export const ScreenPrintTransfer = '4';
export const ScreenPrint = '5';
// export const NylonFlex = '6';
// export const BumperSticker = '7';
export const Embroidery = '8';
// export const DigitalTransferOverlay = '9';
// export const ThermalSublimation = '10';
// export const ColdTransfer = '11';
// export const EmbroideryTransfer = '12';
export const Flex = '14';
// export const Rhinestones = '15';
export const SpecialFlex = '16';
// export const DigitalDirect = '17';
// export const WriteableFlex = '18';
// export const DigitalDirectInactive = '19';
// export const Laser = '20';
// export const Button = '21';
// export const ThermoFoil = '22';
// export const SmartphoneCover = '23';
// export const PosterAndCanvas = '24';
// export const Mug = '25';
// export const LaserTransfer = '26';
// export const Polyester = '27';
export const Sticker = '28';
export const BumperSticker = '36';
// export const BlackSublimation = '29';
// export const TurboFlex = '30';
// export const ScreenPrintBackend = '31';
// export const DirectToFilm = '32';
export const EmbroideryDigital = '33';
export const PrepunchedEmbroideryPixel = '34';
// export const PrepunchedEmbroideryVector = '35';
